// src/app/core/config.service.ts
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class ConfigService {
  private config: {
    apiUrl: string;
    stripePublishableKey: string;
  } | null = null;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    this.config = await firstValueFrom(
      this.http.get<{
        apiUrl: string;
        stripePublishableKey: string;
      }>("/assets/config.json")
    ).then(
      (config) => {
        console.log("ConfigService - load url", config.apiUrl);
        return config;
      },
      (err) => {
        console.error("ConfigService - load failed", err);
        return null;
      }
    );
  }

  get apiUrl(): string {
    return this.config?.apiUrl ?? "http://localhost:8080";
  }

  get stripePublishableKey(): string {
    return this.config?.stripePublishableKey ?? "";
  }
}
